import { OwlOptions } from 'ngx-owl-carousel-o';

export const OwlDefaultConfig: OwlOptions = {
    loop: false,
    margin: 30,
    nav: true,
    navText: ['<i class="icon-left-open-big">', '<i class="icon-right-open-big">'],
    dots: false,
    autoHeight: false,
    autoplay: true,
    autoplayTimeout: 15e3,
    items: 1,
    responsive: {
        0: {
            items: 2
        },
        480: {
            items: 2
        },
        768: {
            items: 3
        },
        992: {
            items: 4
        }
    }
};

export enum CookieKey {
    AgrVerification = 'age-verification'
}
